import { FormattedNumber, FormattedMessage } from 'react-intl';


export default function formatMessageWithPrice(message, info) {

  const values = {
    price: <FormattedNumber value={info.price}
                            style="currency"
                            currency={info.currency}
                            minimumFractionDigits={0} />,
  };

  return (
    <FormattedMessage {...message}
                      values={values} />
  );
}



// WEBPACK FOOTER //
// ./src/widget/utils/format-message-with-price.js